/* KUDEN Private Salon — /pages/private-salon
   Behaviour for sections/kuden-concierge-salon.liquid.

   All content comes from the DOM (Liquid writes <template> elements), so this
   file holds no copy and no product data. Measurement is dataLayer only:
   no Shopify custom pixel, no Shopify.analytics.publish, and no commerce
   events (add_to_cart / begin_checkout / purchase) are emitted from here. */

(function () {
  var root = document.querySelector('[data-kuden-salon]');
  if (!root) return;

  var id = root.getAttribute('data-section-id');
  var q = function (sel) { return root.querySelector(sel); };
  var byId = function (suffix) { return document.getElementById('ks-' + suffix + '-' + id); };

  var drawer = byId('drawer');
  var consult = byId('consult');
  var lightbox = byId('lightbox');
  var ribbon = byId('ribbon');

  /* ---------- data ---------- */
  var GARMENTS = [];
  var H = {};
  Array.prototype.forEach.call(root.querySelectorAll('template[data-ks-garment]'), function (t) {
    var g = {
      handle: t.getAttribute('data-handle') || '',
      name: t.getAttribute('data-name') || '',
      img: t.getAttribute('data-image') || '',
      url: t.getAttribute('data-url') || '',
      price: t.getAttribute('data-price') || '',
      note: t.getAttribute('data-note') || '',
      lead: t.getAttribute('data-lead') || '',
      chart: t.innerHTML || ''
    };
    if (!g.handle) return;
    H[g.handle] = GARMENTS.length;
    GARMENTS.push(g);
  });
  if (!GARMENTS.length) return;

  var DOCS = {};
  Array.prototype.forEach.call(root.querySelectorAll('template[data-ks-doc]'), function (t) {
    DOCS[t.getAttribute('data-ks-doc')] = {
      title: t.getAttribute('data-title') || '',
      kicker: t.getAttribute('data-kicker') || '',
      src: t.getAttribute('data-src') || '',
      dynamic: t.getAttribute('data-ks-doc') === 'size',
      body: t.innerHTML || ''
    };
  });

  var STR = {};
  try { STR = JSON.parse(q('[data-ks-strings]').textContent) || {}; } catch (e) { STR = {}; }

  /* ---------- where the visitor came in ----------
     Only these four doors exist. Anything else in the URL is treated as a
     direct arrival, and no parameter value is ever written into the page. */
  var KNOWN_SOURCES = ['home', 'product', 'concierge_legacy', 'direct'];

  function urlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) { return ''; }
  }

  var entrySource = urlParam('source');
  if (KNOWN_SOURCES.indexOf(entrySource) === -1) entrySource = 'direct';

  /* ---------- state ---------- */
  var idx = 0;
  var lastFocus = null;
  var currentContext = STR.context_salon || '';
  var zoomFrom = null;
  var scenes = [].slice.call(root.querySelectorAll('.ks-scene'));

  function track(action, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: 'kuden_concierge_interaction',
      concierge_action: action,
      concierge_entry_source: entrySource,
      concierge_product_handle: (GARMENTS[idx] && GARMENTS[idx].handle) || ''
    };
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k]; } }
    window.dataLayer.push(payload);
  }

  function show(name) {
    scenes.forEach(function (s) { s.removeAttribute('data-active'); });
    var el = q('[data-ks-scene="' + name + '"]');
    if (!el) return;
    el.setAttribute('data-active', '');
    var styles = getComputedStyle(document.documentElement);
    var stickyHeight = parseFloat(styles.getPropertyValue('--theme-sticky-header-height')) ||
      parseFloat(styles.getPropertyValue('--theme-header-height')) || 0;
    var top = root.getBoundingClientRect().top + window.pageYOffset - stickyHeight - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    var h = el.querySelector('h1,h2');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }

  function renderGarment(i) {
    idx = (i + GARMENTS.length) % GARMENTS.length;
    var g = GARMENTS[idx];
    var img = q('[data-ks-g-img]');
    img.src = g.img;
    img.alt = g.name;
    q('[data-ks-g-name]').textContent = g.name;
    q('[data-ks-g-note]').textContent = g.note;
    q('[data-ks-g-price]').textContent = g.price ? g.price + (STR.price_suffix ? '  /  ' + STR.price_suffix : '') : '';
    q('[data-ks-lead-line]').textContent = g.lead;
    var view = q('[data-ks-g-view]');
    if (g.url) { view.href = g.url; view.hidden = false; } else { view.hidden = true; }
    currentContext = g.name;
    track('garment_shown', { concierge_product_handle: g.handle });
  }

  /* ---------- entry ---------- */
  var enter = q('[data-ks-enter]');
  if (enter) {
    enter.addEventListener('click', function () {
      root.setAttribute('data-entered', '');
      if (ribbon) ribbon.setAttribute('data-visible', '');
      show('greeting');
      track('enter_salon');
    });
  }

  /* ---------- intents ---------- */
  function urlProduct() {
    var p = urlParam('product');
    return Object.prototype.hasOwnProperty.call(H, p) ? p : '';
  }

  var lookbook = q('[data-ks-lookbook]');
  if (lookbook) {
    lookbook.addEventListener('click', function () {
      track('intent_selected', { concierge_intent: 'occasion' });
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-ks-intent]'), function (b) {
    b.addEventListener('click', function () {
      var intent = b.getAttribute('data-ks-intent');
      track('intent_selected', { concierge_intent: intent });

      if (intent === 'first') {
        var want = root.getAttribute('data-ks-' + intent + '-handle') || '';
        var target = Object.prototype.hasOwnProperty.call(H, want) ? H[want] : 0;
        renderGarment(target);
        show('garment');
        return;
      }

      if (intent === 'practical') {
        currentContext = STR.context_practical || currentContext;
        show('practical');
        return;
      }

      if (intent === 'size') {
        var p = urlProduct();
        if (p) {
          renderGarment(H[p]);
          show('garment');
          openDoc('size');
        } else {
          buildPickList();
          show('pick');
        }
      }
    });
  });

  function buildPickList() {
    var wrap = q('[data-ks-pick-list]');
    if (!wrap || wrap.childElementCount) return;
    GARMENTS.forEach(function (g, i) {
      var b = document.createElement('button');
      b.className = 'ks-choice';
      b.type = 'button';
      var span = document.createElement('span');
      span.className = 'ks-lead';
      span.textContent = g.name;
      b.appendChild(span);
      b.addEventListener('click', function () {
        track('size_target_selected', { concierge_product_handle: g.handle });
        renderGarment(i);
        show('garment');
        openDoc('size');
      });
      wrap.appendChild(b);
    });
  }

  var SCENE_CONTEXT = {
    greeting: 'context_salon',
    pick: 'context_salon',
    practical: 'context_practical',
    process: 'context_process'
  };

  Array.prototype.forEach.call(root.querySelectorAll('[data-ks-go]'), function (b) {
    b.addEventListener('click', function () {
      var to = b.getAttribute('data-ks-go');
      if (to === 'next') { renderGarment(idx + 1); return; }
      if (to === 'garment') { renderGarment(idx); show('garment'); return; }
      if (SCENE_CONTEXT[to]) currentContext = STR[SCENE_CONTEXT[to]] || currentContext;
      show(to);
      if (to === 'process') track('process_opened');
    });
  });

  /* ---------- documents ---------- */
  function openDoc(key) {
    var d = DOCS[key];
    if (!d || !drawer) return;
    lastFocus = document.activeElement;
    drawer.querySelector('[data-ks-doc-h]').textContent = d.title;
    drawer.querySelector('[data-ks-doc-kicker]').textContent = d.kicker;

    var body = drawer.querySelector('[data-ks-doc-body]');
    if (d.dynamic) {
      var g = GARMENTS[idx];
      var intro = document.createElement('p');
      intro.textContent = (STR.size_intro || '').replace('%s', g.name);
      body.innerHTML = '';
      if (intro.textContent) body.appendChild(intro);
      if (g.chart) {
        var holder = document.createElement('div');
        holder.innerHTML = g.chart;
        if (STR.charts_only) holder = chartsOnly(holder);
        makeZoomable(holder, g.name);
        while (holder.firstChild) body.appendChild(holder.firstChild);
      } else if (STR.size_missing) {
        var miss = document.createElement('p');
        miss.textContent = STR.size_missing;
        body.appendChild(miss);
      }
    } else {
      body.innerHTML = d.body;
    }

    drawer.querySelector('[data-ks-doc-src]').innerHTML = d.src;
    drawer.setAttribute('data-open', '');
    drawer.querySelector('[data-ks-close-drawer]').focus();
    track('document_opened', { document_name: key, concierge_product_handle: d.dynamic ? GARMENTS[idx].handle : '' });
  }

  /* The size-chart page carries its own headings and English guidance. The
     salon has already said all of that in its own voice, so by default only
     the drawings and tables come across. */
  function chartsOnly(holder) {
    var match = STR.charts_match || '';
    var keep = document.createElement('div');
    Array.prototype.forEach.call(holder.querySelectorAll('img,table'), function (el) {
      if (el.tagName === 'IMG') {
        if (el.closest('table')) return;
        /* the page also carries banners and explainers; keep the drawings */
        if (match && (el.getAttribute('src') || '').indexOf(match) === -1) return;
      }
      keep.appendChild(el);
    });
    if (keep.childElementCount) return keep;
    /* nothing matched: fall back rather than show an empty drawer */
    if (match) {
      STR.charts_match = '';
      var again = document.createElement('div');
      again.innerHTML = holder.innerHTML;
      var out = chartsOnly(again);
      STR.charts_match = match;
      return out;
    }
    return holder;
  }

  /* Wrap every image inside the size-chart HTML in a zoom button. */
  function makeZoomable(holder, name) {
    Array.prototype.forEach.call(holder.querySelectorAll('img'), function (im) {
      var src = im.getAttribute('src');
      if (!src) return;
      var label = im.getAttribute('alt') || name;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ks-chart-btn';
      btn.setAttribute('data-ks-zoom', src);
      btn.setAttribute('data-ks-zoom-alt', label);
      im.parentNode.insertBefore(btn, im);
      btn.appendChild(im);
      if (STR.zoom_hint) {
        var hint = document.createElement('span');
        hint.className = 'ks-zoom-hint';
        hint.textContent = STR.zoom_hint;
        btn.appendChild(hint);
      }
    });
  }

  function closeDoc() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- consult ---------- */
  function openConsult() {
    if (!consult) return;
    lastFocus = document.activeElement;
    var line = STR.sendline_prefix ? STR.sendline_prefix + currentContext : currentContext;
    consult.querySelector('[data-ks-sendline]').textContent = line;
    consult.setAttribute('data-open', '');
    consult.querySelector('[data-ks-close-consult]').focus();
    track('consult_opened', { consult_context: currentContext });
  }

  function closeConsult() {
    if (!consult) return;
    consult.removeAttribute('data-open');
    if (lastFocus) lastFocus.focus();
  }

  function closeZoom() {
    if (!lightbox) return;
    lightbox.removeAttribute('data-open');
    if (zoomFrom) { zoomFrom.focus(); zoomFrom = null; }
  }

  /* ---------- delegated clicks (root + overlays) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var docBtn = t.closest('[data-ks-open-doc]');
    if (docBtn && (root.contains(docBtn) || (drawer && drawer.contains(docBtn)))) {
      openDoc(docBtn.getAttribute('data-ks-open-doc'));
      return;
    }

    var zoomBtn = t.closest('[data-ks-zoom]');
    if (zoomBtn && drawer && drawer.contains(zoomBtn)) {
      zoomFrom = zoomBtn;
      var zi = lightbox.querySelector('[data-ks-zoom-img]');
      zi.src = zoomBtn.getAttribute('data-ks-zoom');
      zi.alt = zoomBtn.getAttribute('data-ks-zoom-alt') || '';
      lightbox.setAttribute('data-open', '');
      lightbox.querySelector('[data-ks-close-zoom]').focus();
      track('size_chart_zoom', { concierge_product_handle: GARMENTS[idx].handle });
      return;
    }

    if (t.closest('[data-ks-consult]')) { openConsult(); return; }
    if (t.closest('[data-ks-close-drawer]')) { closeDoc(); return; }
    if (t.closest('[data-ks-close-consult]')) { closeConsult(); return; }
    if (t.closest('[data-ks-close-zoom]')) { closeZoom(); return; }
    if (drawer && t === drawer) { closeDoc(); return; }
    if (consult && t === consult) { closeConsult(); return; }
    if (lightbox && t === lightbox) { closeZoom(); return; }
  });

  /* ---------- chat ----------
     <shopify-chat> exposes show()/close(); `open` is a boolean property, not
     a method. The widget also hydrates asynchronously, so a call that does
     not throw has not necessarily opened anything — watch `open` and try
     again before telling the visitor it failed. */
  function ask(el) {
    try {
      if (typeof el.open === 'function') { el.open(); return; }
      if (typeof el.show === 'function') { el.show(); return; }
      if ('open' in el) { el.open = true; }
    } catch (err) { /* the check below decides */ }
  }

  /* Second attempt: press the widget's own button. */
  function pressActivator(el) {
    try {
      var root = el.shadowRoot;
      if (!root) return;
      var btn = root.querySelector('button.activator, button[class*="activator"], button');
      if (btn) btn.click();
    } catch (err) { /* the check below decides */ }
  }

  function launchChat(done) {
    var el = document.querySelector('shopify-chat');
    if (!el) { done(false); return; }
    ask(el);
    if (typeof el.open !== 'boolean') { done(true); return; }

    var tries = 0;
    (function check() {
      if (el.open === true) { done(true); return; }
      tries += 1;
      if (tries === 3) ask(el);
      if (tries === 6) pressActivator(el);
      if (tries > 9) { done(false); return; }
      setTimeout(check, 150);
    })();
  }

  var chatBtn = consult && consult.querySelector('[data-ks-open-chat]');
  if (chatBtn) {
    chatBtn.addEventListener('click', function () {
      track('chat_open_attempt', { consult_context: currentContext });

      /* Step out of the way first: two dialogs stacked on a phone leaves the
         visitor with nothing to read. If the chat never arrives, come back. */
      var returnFocus = lastFocus;
      closeConsult();

      launchChat(function (opened) {
        if (opened) return;
        var fb = consult.querySelector('[data-ks-chat-fallback]');
        if (fb) { fb.hidden = false; }
        lastFocus = returnFocus;
        consult.setAttribute('data-open', '');
        consult.querySelector('[data-ks-close-consult]').focus();
        track('chat_open_failed', { consult_context: currentContext });
      });
    });
  }

  /* ---------- keyboard ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lightbox && lightbox.hasAttribute('data-open')) closeZoom();
    else if (consult && consult.hasAttribute('data-open')) closeConsult();
    else if (drawer && drawer.hasAttribute('data-open')) closeDoc();
  });

  /* ---------- deep link: /pages/private-salon?product=<handle> ---------- */
  (function deepLink() {
    var p = urlProduct();
    if (!p) return;
    root.setAttribute('data-entered', '');
    if (ribbon) ribbon.setAttribute('data-visible', '');
    renderGarment(H[p]);
    show('garment');
    track('deep_link_entry', { concierge_product_handle: p });
  })();
})();
